
<ng-container *ngIf="answer$ | async as answer">
      @for(paragraph of answer; track paragraph) {
         <p class="t-summary mb-2" aria-live="polite" *transloco="let t" [attr.lang]="language">
            @for(wordOrNumber of paragraph; track wordOrNumber) {
               @if(isString(wordOrNumber)) {
                  {{ wordOrNumber }}
               }
               @else {
                  @for(annotation of getAnnotations(wordOrNumber); track annotation) {
                     <button
                        [attr.aria-label]="t('answer.sourcetitledefault', {index: annotation})"
                        [attr.title]="t('answer.sourcetitledefault', {index: annotation})"
                        [attr.aria-describedby]="'source_title_' + annotation"
                        (click)="parent.selectSource(annotation)"
                        [ngClass]="{
                           'bg-gradient-to-l from-cdra-blue-light-main from-20% to-cdra-green-main  ':
                           parent.selectedSourceIndex === annotation,
                           'bg-stone-500': parent.selectedSourceIndex !== annotation,
                        }"
                        class="t-source-annotation rounded-full size-4 me-1 inline-flex justify-center items-center flex-shrink-0 align-super hover:bg-gradient-to-l hover:from-cdra-blue-light-main from-20% hover:to-cdra-green-main"
                     >
                        <span
                           aria-hidden="true"
                           class="text-white text-center text-sm font-bold"
                        >
                           {{ annotation }}
                        </span>
                     </button>
                  }
               }
            }
         </p>
      }
</ng-container>